import { useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';

import { HistoryList } from '../components/history/HistoryList';
import { PageHeader } from '../components/ui/PageHeader';
import { apiClient } from '../lib/api-client';
import { useUserStore } from '../stores/user-store';

export function HistoryPage() {
  const setHistory = useUserStore((state) => state.setHistory);

  const historyQuery = useQuery({
    queryKey: ['history'],
    queryFn: () => apiClient.history(1, 10),
  });

  useEffect(() => {
    if (historyQuery.data) {
      setHistory(historyQuery.data.items);
    }
  }, [historyQuery.data, setHistory]);

  return (
    <div className="space-y-6">
      <PageHeader
        badge={historyQuery.data ? `${historyQuery.data.total} totali` : 'Archivio'}
        description="Letture salvate nelle tabelle custom del plugin con mapping nativo all'utente WordPress."
        eyebrow="Archivio"
        title="Reading history"
      />

      <HistoryList items={historyQuery.data?.items ?? []} />
    </div>
  );
}
